import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Portfolio from './pages/Portfolio';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Redes from './pages/Redes';
import Promo250705 from './components/Promociones/Promo250705';
import StaticHtmlPage from './components/StaticHtmlPage';

function App() {
  return (
    <>
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/portafolio" element={<Portfolio />} />
          <Route path="/servicios" element={<Services />} />
          <Route path="/contacto" element={<Contact />} />
          <Route path="/redes" element={<Redes />} />
          // Otras rutas
          <Route path="/promociones/250705" element={<Promo250705 />} />
          <Route
            path="/aviso-de-privacidad"
            element={
              <StaticHtmlPage
                title="Aviso de Privacidad"
                htmlPath="/legal/aviso_privacidad.html"
              />
            }
          />
          <Route
            path="/terminos-de-pago-electronico"
            element={
              <StaticHtmlPage
                title="Términos de Pago Electrónico"
                htmlPath="/legal/terminos_de_pago.html"
              />
            }
          />
          {/* Ruta catch-all para 404 */}
          <Route path="*" element={<div>Página no encontrada</div>} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

export default App;
